import React from 'react';

/**
 * Real peeled/carved tender coconut PNG used across the site as the
 * live-preview canvas. Provided by the user – hosted on Emergent CDN.
 */
export const COCONUT_IMAGE_URL =
  'https://customer-assets-jt897jd0.emergentagent.net/job_coconuts-stage/artifacts/i3711u2b_ChatGPT%20Image%20Aug%201%2C%202026%2C%2004_57_54%20PM.png';

/**
 * Renders the real coconut PNG as a full-bleed canvas. Overlay children
 * (typically the engraved text) are absolutely centered inside the white
 * body of the coconut.
 */
const CoconutCanvas = ({ children }) => {
  return (
    <div className="relative w-full h-full flex items-center justify-center">
      <img
        src={COCONUT_IMAGE_URL}
        alt="Custom coconut preview"
        className="absolute inset-0 w-full h-full object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.35)]"
        draggable={false}
      />
      {/* Overlay slot – anchored roughly at the coconut's white body area */}
      <div
        className="absolute pointer-events-none flex items-center justify-center text-center"
        style={{
          top: '38%',
          left: '18%',
          right: '18%',
          bottom: '18%',
        }}
      >
        <div className="max-w-full">{children}</div>
      </div>
    </div>
  );
};

export default CoconutCanvas;
